import common from './common.js'
import api from 'api'
import modal from './modal.js'
import util from 'util/common'

const imageUploadTask = (context, endpoint, state) => {
  return common.isFile(endpoint.image)
  ? api.sendImage(context, endpoint.path, endpoint.image).then(res => {
    let value = state.index !== undefined ? { index: state.index, data: res.url } : res.url
    context.$store.commit(state.mutation, value)
    return res.url
  })
  : Promise.resolve(endpoint.image)
}

const sendEvent = (context, status) => {
  let eventForm = context.$store.state.eventForm
  // イベント入力画面で更新するとevent_noがクリアされるため
  // 0を設定しておく
  context.$store.commit('updateEventNo', 0)
  let sendPromise = eventForm.images.map((image, index) =>
  imageUploadTask(context,
    { path: 'event', image: image },
    { mutation: 'updateImages', index: index }))
  Promise.all(sendPromise).then(_ => {
    let img = eventForm.images.filter(i => typeof i === 'string')
    let obj = {
      ...eventForm,
      image1: img[0] || '',
      image2: img[1] || '',
      end_date: common.parseDateToSendAPI(eventForm.end_date),
      status: status
    }
    delete obj['images']
    let promise = !context.$route.query.id
    ? api.registerNewEvent(context, obj)
    : api.updateEvent(context, obj)
    promise.then(_ =>
      context.$router.push('/list'))
    .catch(
      onFetchError(context))
  }).catch(
    onFetchError(context))
}
const onFetchError = (context) => {
  return (err) => {
    if (err.status === 401) {
      modal.showLoginModal(context)
    } else {
      modal.showErrorModal(context, err)
    }
    context.isDisabled = false
  }
}

const commonRequired = [
  'event_name',
  'lecturer_name',
  'event_date',
  // 'event_date_public',
  'description',
  'fee',
  'published',
  'email',

  'zipcode',
  'prefecture',
  'city',
  'address1'
]
const eventRequired = [
  'participant',
  'sponsor'
]
const validateForm = (form) => {
  let validation = {}
  if (!form.event_kind) {
    validation.event_kind = '必ず選択してください。'
    return validation
  }

  let required = form.event_kind === 'event'
  ? [...commonRequired, ...eventRequired]
  : commonRequired
  required
  .filter(k => !form[k] || !form[k].length)
  .forEach(k => { validation[k] = '必ず入力してください。' })

  if (!form.event_date_public && !form.event_date_public_multi) {
    validation.event_date_public = '必ず入力してください。'
  }

  if (form.event_kind === 'event' && form.sponsor === 'あり' && !form.sponsor_name) {
    validation.sponsor_name = '必ず入力してください。'
  }

  if (!validation.zipcode && !validateZipcode(form.zipcode)) {
    validation.zipcode = '郵便番号を正しく入力してください。'
  }
  if (!validation.email && !validateEmail(form.email)) {
    validation.email = '正しいEメールアドレスを入力してください。'
  }
  ['homepage', 'lecturer_url', 'entry_url']
  .filter(k => !validation[k] && !validateUrl(form[k]))
  .forEach(k => { validation[k] = '正しいURLを入力してください。' })

  if (!validation.line_at && !validateLineAt(form.line_at)) {
    validation.line_at = '@から始まるアカウントを入力して下さい'
  }

  var endDateArray = form.event_date_public_multi.split(',')
  if (isArrayValueDuplicate(endDateArray)) {
    validation.event_date_public = '開催日が重複しています'
  }
  var dt = new Date()
  var month = dt.getMonth()
  var threeMonth = dt.setMonth(month + 3)
  var inputEndDate = toDate(form.end_date, '/').getTime()
  if (inputEndDate > threeMonth) {
    validation.event_date_public = '3ヶ月以内のイベントを入力してください。'
  }

  return validation
}

const lecturerFormRequired = [
  'name',
  'name_kana',
  'published',
  'birthday',
  'zipcode',
  'prefecture',
  'city',
  'address1',
  'tel'
]
const validateLecturerForm = (context) => {
  var validation = {}
  lecturerFormRequired.filter(k => !context[k])
  .forEach(k => { validation[k] = '必ず入力してください。' })

  if (!validation.zipcode && !validateZipcode(context.zipcode)) {
    validation.zipcode = '郵便番号を正しく入力してください。'
  }

  if (context.published === 'true') {
    if (!context.lecturer_name) {
      validation.lecturer_name = '協会ホームページに掲載する場合は、必ず入力して下さい。'
    }

    if (!context.lecturer_name_kana) {
      validation.lecturer_name_kana = '協会ホームページに掲載する場合は、必ず入力して下さい。'
    }

    if (!context.active_area1) {
      validation.active_area1 = '協会ホームページに掲載する場合は、必ず入力して下さい。'
    }
  }

  if (!context.birthday.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
    validation.birthday = '誕生日はYYYY/MM/DDの形式で入力してください'
  } else if (!common.isDate(context.birthday)) {
    validation.birthday = '誕生日の日付を確認してください'
  }

  if (context.line && !validateLineAt(context.line)) {
    validation.line = '@から始まるアカウントを入力して下さい'
  }

  ['homepage', 'facebook', 'blog']
  .filter(k => !validation[k] && !validateUrl(context[k]))
  .forEach(k => { validation[k] = '正しいURLを入力してください。' })
  return validation
}

const validateZipcode = (zipcode) => {
  return zipcode.match(/^\d{3}-\d{4}$/)
}

const validateEmail = (email) => {
  return !email || email.match(/^[a-zA-Z\d_.+-]+@[a-zA-Z\d_.-]+$/)
}

const validateUrl = (url) => {
  return !url || url.match(/^https?:\/\/.*$/)
}

const validateLineAt = (line) => {
  return !line || line.match(/^@.*$/)
}

const isInvalidLocalStrage = () => {
  localStorage.setItem('check_localstorage', 'OK')
}

const eventEndDate = (context) => {
  let newList = []
  context.endDate
    .filter(i => i.date !== '' || i.date === 'undefined')
    .forEach(i => { newList.push(i.date) })

  if (newList.length === 0) {
    return
  }
  // 最大の日付を取得
  let d = util.maxDate(newList)

  newList.forEach((x, i, a) => {
    a[i] = util.toStringFromDateString(x)
  })

  d = util.toStringFromDateString(d)

  context.$store.commit('updateEndDate', d)
  context.$store.commit('updateEventDatePublicMulti', newList)

  return d
}

const isArrayValueDuplicate = (ary) => {
  var counts = {}
  for (var i = 0; i < ary.length; i++) {
    var key = ary[i]
    if (key === '') {
      continue
    }
    if (counts[key]) {
      return true
    }
    counts[key] = 1
  }
  return false
}

const isNumber = (num) => {
  return num.match(/^\d{1,}$/)
}

const toDate = (str, delim) => {
  var arr = str.split(delim)
  return new Date(arr[0], arr[1] - 1, arr[2])
}

export default {
  validateForm,
  validateLecturerForm,
  validateEmail,
  sendEvent,
  imageUploadTask,
  isInvalidLocalStrage,
  eventEndDate,
  isNumber
}



// WEBPACK FOOTER //
// ./src/util/lecturer.js